var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dropdown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown_24dp_5F6368_FILL0_wght500_GRAD0_opsz24-1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dropdown_24dp_5F6368_FILL0_wght500_GRAD0_opsz24-1-(Background/Mask)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9844661,21.7861325 C28.5164105,21.7861325 28.965439,21.6032165 29.3315501,21.2373832 C29.6973834,20.8712721 29.8802994,20.4222436 29.8802994,19.8902992 L29.8802994,12.0152993 C29.8802994,11.4833549 29.6973834,11.0343264 29.3315501,10.6682153 C28.965439,10.302382 28.5164105,10.119466 27.9844661,10.119466 L20.1094662,10.119466 C19.5775218,10.119466 19.1284933,10.302382 18.7623822,10.6682153 C18.3965489,11.0343264 18.2136329,11.4833549 18.2136329,12.0152993 L18.2136329,19.8902992 C18.2136329,20.4222436 18.3965489,20.8712721 18.7623822,21.2373832 C19.1284933,21.6032165 19.5775218,21.7861325 20.1094662,21.7861325 L27.9844661,21.7861325 Z M5.7698825,34.2298832 C5.03071586,33.4907166 4.66113281,32.5964104 4.66113281,31.546966 L4.66113281,8.4527994 C4.66113281,7.40335499 5.03071586,6.50904882 5.7698825,5.76988218 C6.50904914,5.03071554 7.40335467,4.66113281 8.45279908,4.66113281 L31.546966,4.66113281 C32.5964104,4.66113281 33.4907166,5.03071554 34.2298832,5.76988218 C34.9690499,6.50904882 35.3386326,7.40335499 35.3386326,8.4527994 L35.3386326,31.546966 C35.3386326,32.5964104 34.9690499,33.4907166 34.2298832,34.2298832 C33.4907166,34.9690499 32.5964104,35.3386326 31.546966,35.3386326 L8.45279908,35.3386326 C7.40335467,35.3386326 6.50904914,34.9690499 5.7698825,34.2298832 Z M31.546966,31.546966 L31.546966,8.4527994 L8.45279908,8.4527994 L8.45279908,31.546966 L31.546966,31.546966 Z",
    id: "Vector",
    fill: "#9CABBD",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.4e53d421c1fc0ab4bae36ef1a8cf5656.svg";
export { ForwardRef as ReactComponent };